import React, { useEffect, useState } from 'react';
import { TableCell } from "@mui/material";
import localStrings from "../../../localStrings";
import useAuth from "../../../hooks/useAuth";
import useAppUtil from "../../../hooks/useAppUtil";
import {executeMutationUtil, executeQueryUtil} from "../../../utils/gqlUtil";
import ClipLoaderComponent from "../../../components/ClipLoaderComponent";
import GeneralResult from "../../../components/CrudFrom/GeneralResult";
import {bulkDeleteBoardMutation, deleteBoardCache, getAllBoardsQuery} from "../../../gql/boardGql";
import {
  bulkDeleteStripePayAccountMutation,
  deleteStripePayAccountCache,
  getAllStripePayAccountsQuery
} from "../../../gql/stripePayAccountGql";

const Results = ({className, ...rest}) => {
  const { currentBrand } = useAuth();
  const { addWarning, addError} = useAppUtil();
  const [itemSource, setItemSource] = useState({});

  useEffect(() => {
    async function setItemSourceAsync() {
      let result = await getAccounts();
      setItemSource(result);
    }
    setItemSourceAsync();
  }, [currentBrand]);


  const getAccounts = async () => {
    return await executeQueryUtil(getAllStripePayAccountsQuery(currentBrand().id));
  }

  const getTableCellColumn = () => {
    return(
      <React.Fragment>
        <TableCell>
          {localStrings.stripePayAccountName}
        </TableCell>
      </React.Fragment>
    )
  }

  const getTableCell = (item) => {
    return(
      <React.Fragment>
        <TableCell>
          {item.name}
        </TableCell>
      </React.Fragment>
    )
  }

  const deleteStripePayAccounts = async (ids, size) => {
    await executeMutationUtil(bulkDeleteStripePayAccountMutation(currentBrand().id, ids));
    await deleteStripePayAccountCache(currentBrand().id, ids);
    let itemUpdate = await getAccounts();
    setItemSource(itemUpdate)
    return true;
  }


  const sortOptions = [
    {
      value: 'tag|asc',
      label: localStrings.stripePayAccountName
    },
  ];

  return (
    <>
      { Object.keys(itemSource).length > 0 ?
        <GeneralResult
          className={className}
          getPathToData={(result) => result.data.getStripePayAccounts}
          getTableCell={getTableCell}
          getTableCellColumn={getTableCellColumn}
          getEditLink={(item) => "/app/stripePayAccounts/detail/" + item.id}
          deleteDialogText={localStrings.confirmMessage.deleteStripePayAccount}
          deleteItemsFunction={deleteStripePayAccounts}
          deleteItemNotifMessage={localStrings.notif.stripePayAccountDeleted}
          sortOptions={sortOptions}
          searchProperties={['name']}
          itemsSource={itemSource}
        >
        </GeneralResult>
        :
        <ClipLoaderComponent/>
      }
    </>
  )

};


export default Results;
